module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"新着ニュース"},"en":{"title":"News (For now, only available in Japanese)"}}')
  delete Component.options._Ctor
}
